import React from "react";
import { Navbar } from "react-bootstrap";
import { Bug, Lightbulb, QuestionLg } from "react-bootstrap-icons";

// Footer including link for bug report.
function Footer(_props) {
  return (
    <Navbar className="footer" bg="primary" variant="dark" sticky="bottom">
      <Navbar.Brand
        className="custom-brand"
        href="https://www.cs.jhu.edu/"
        target="_blank"
      >
        Department of Computer Science @ JHU
      </Navbar.Brand>
      <Navbar.Toggle />
      <Navbar.Collapse className="justify-content-end">
        <Navbar.Text>
          <span className="footer-label-bug">Report </span>
          <a
            href="https://github.com/jhu-cs-ca-hiring/community/issues/new/choose"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="footer-label-bug">Bug</span> <Bug />
          </a>
          {" | "}
          <span className="footer-label-feature">Request </span>
          <a
            href="https://github.com/jhu-cs-ca-hiring/community/issues/new/choose"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="footer-label-feature">Feature</span> <Lightbulb />
          </a>
          {" | "}
          <span className="footer-label-question">Ask </span>
          <a
            href="https://github.com/jhu-cs-ca-hiring/community/discussions"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="footer-label-question">Question</span>{" "}
            <QuestionLg />
          </a>
        </Navbar.Text>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Footer;
